/**
 * Fields that support multi-select operators (hasAnyOf, hasNoneOf)
 * These fields can display as list type when used with multi-select operators
 */
export const MULTI_SELECT_FIELDS = [
  'country_name',
  'city_name',
  'conversationOpenBySource',
  'conversationOpenByChannel',
  'conversationContactType',
] as const;

/**
 * Type for multi-select field keys
 */
export type MultiSelectFieldKey = (typeof MULTI_SELECT_FIELDS)[number];

/**
 * Check if a given key is a multi-select field
 */
export const isMultiSelectField = (key: string): key is MultiSelectFieldKey => {
  return MULTI_SELECT_FIELDS.includes(key as MultiSelectFieldKey);
};
